module.exports = __webpack_public_path__ + "img/2.f093e183.png";